/**
 * Represents a type of condition.
 * Current we have 2 possible types: a simple condition or a predicate - a group of conditions
*/
export var CondTag;
(function (CondTag) {
    /** An unknown type of condition (just in case).*/
    CondTag[CondTag["Unknown"] = 0] = "Unknown";
    /** A simple condition (e.g. SomeField > SomeValue).*/
    CondTag[CondTag["Simple"] = 1] = "Simple";
    /** A predicate (a group of conditions).*/
    CondTag[CondTag["Group"] = 51] = "Group";
})(CondTag || (CondTag = {}));
//# sourceMappingURL=cond_tag.js.map